import React from "react";
import { Checkbox as NBCheckbox, ICheckboxProps } from "native-base";

export const Checkbox = (props: ICheckboxProps) => {
  const [groupValues, setGroupValues] = React.useState([]);
  return <NBCheckbox.Group onChange={setGroupValues} value={groupValues}>
      <NBCheckbox value="one" my={2}>
        Item 1
      </NBCheckbox>
      <NBCheckbox value="two">Item 2</NBCheckbox>
    </NBCheckbox.Group>;
};